module.exports = __webpack_public_path__ + "static/media/translate.ac5b49f5.png";